export default {
  'form.advancedform.basic.title': '高级表单',
};
